import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const StacksAndItsApplications = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Stacks and Its Applications"
    videos={[
      "https://www.youtube.com/embed/I37kGX-nZEI?list=PLBlnK6fEyqRgWh1emltdMOz8O2m5X3YYn",
      "https://www.youtube.com/embed/4pIc9UBHJtk",
      "https://www.youtube.com/embed/xwjS0iZhw4I"
    ]}
    takeaways={[
      { text: "Clearly learn the basic operations of the stack; exam may include scenario-based implementation questions." },
      { text: "For lab purposes, learn Array Based and Linked List Based implementations of stack along with their advantages & disadvantages." },
      { text: "The 50+ minutes Take U Forward video covers applications and pseudo codes essential for exams; practice example problems." }
    ]}
    questions={[
      "Convert the given Infix notation into its equivalent postfix notation and show step trace with the conversion algorithm. Infix notation: (a/(b-c+d))*(e-a)*c",
      "In a stack, four numbers 1, 2, 3, 4 can be pushed or popped in any random order. Each number can be pushed or popped multiple times. Popping a number prints it. The sequence of operations performed on the stack is Push > Push > Pop > Push > Pop > Pop > Push > Pop > Push. This sequence printed the numbers 1, 1, 3, 2 in that order. Which number was pushed first? Justify your answer.",
      "Convert (A/B) AC + ((D +E)*F AC) to postfix and then evaluate the expression for A = 18, B = 3, C = 2, D = 13, E = 7, and F = 5 using an appropriate data structure. The processing of each symbol and status of the data structure at each step is expected in both conversion and evaluation.",
      "Illustrate how the given infix expression is converted into a Postfix Expression. Make sure to show all the steps involved in the process. (A-B)/(((D+E)*F)-G)",
      "Illustrate the conversion of the following infix expression b-c*a+(d*e-f)/g to postfix expression and give the algorithm.",
      "Convert the following infix expression to prefix & postfix with its algorithm using stack in detail: x*y / (a*z) + i",
      "Explain which one of the linear ADT suits well for reversing a string with its operations in detail.",
      "Write the steps or algorithm to convert infix expression into postfix expression. Using stack, convert (A - B) / ((D + E) * F) - G into postfix notation.",
      "Consider the following infix expression ((A*B) + (C*D))-E and perform: a) Infix to postfix conversion; b) Infix to prefix conversion; c) Evaluate the prefix expression obtained above using the following values: A=2, B=3, C=5, D=4, E=9 (proper steps to be given)."
    ]}
    exampleVideos={[]}
  />
);
}

export default StacksAndItsApplications;
